import React from "react";
import Button from "../../../../../components/shared/Button";
import TextEditor from "../../../../../components/shared/TextEditor";

const EditBlog = ({
  loading,
  closeModal,
  editModalVisible,
  editedBlogPost,
  handleEditSubmit,
  onEditChange,
  setEditedBlogPost,
}) => {
  return (
    <div
      className={`fixed inset-0 flex items-center justify-center bg-white bg-opacity-95 ${
        editModalVisible ? "block" : "hidden"
      }`}
    >
      <div className="w-full xl:px-12 lg:px-12 px-6">
        <span
          className="font-semibold text-3xl cursor-pointer absolute right-14"
          onClick={closeModal}
        >
          &times;
        </span>
        <h2 className="font-semibold text-xl text-center">Edit Blog Post</h2>
        <form onSubmit={handleEditSubmit}>
          <div className="flex flex-col gap-1">
            <label className="font-FiraSans text-lg"></label>
            <input
              type="text"
              placeholder="Put the blogpost heading here..."
              value={editedBlogPost.heading}
              onChange={onEditChange}
              name="heading"
              required
              className="py-2 px-2 font-FiraSans outline-blue-300 shadow-md ring-transparent border-2 border-gray-400 sm:w-full xs:w-full rounded-md"
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="font-FiraSans text-lg"></label>
            <TextEditor
              value={editedBlogPost.content}
              onChange={(value) =>
                setEditedBlogPost((prev) => ({
                  ...prev,
                  content: value,
                }))
              }
              required
              className="py-2 px-2 font-FiraSans resize-none outline-blue-300 w-full"
            />
          </div>
          <div className="flex justify-center xs:mt-14 sm:mt-16 md:mt-20 mt-8">
            <Button
              type="submit"
              title={loading ? "Updating Post..." : "Update Post"}
              size="md"
              disabled={loading}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditBlog;
